export default __webpack_public_path__ + "static/media/domains.7918318e.svg";